// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:ds:-eno5R */\n.lQ8yA{border:1px solid var(--audio-stroke-default);border-radius:var(--audio-radius-1);display:grid;grid-template-columns:minmax(0,1fr)}.aD8Yi{border-bottom:1px solid var(--audio-stroke-default)}.aD8Yi:last-child{border-bottom:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "lQ8yA",
	"item": "aD8Yi"
};
export default ___CSS_LOADER_EXPORT___;
